import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { storage, TOKEN_INFO } from '../../app/Storage';
import { decode } from 'jsonwebtoken';
import { TokenDecodeHelper } from '../helpers/TokenDecodeHelper';

export class ProviderSelectMenu extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string,
        selectProvider: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            showProviders: false
        };
    }

    providerMenuClickHandler() {
        const { showProviders } = this.state;

        this.setState({
            showProviders: !showProviders
        });
    }

    selectProviderHandler(provider) {
        this.context.selectProvider(provider, true);
        this.setState({
            showProviders: false
        });
    }

    render() {        
        const { showProviders } = this.state;

        let tokenInfo = storage.get(TOKEN_INFO);
        const availableProvidersCollection = TokenDecodeHelper.getAvailableProviders(tokenInfo, (a) => decode(a));

        if (availableProvidersCollection.length > 0) {
            let selectedProvider;

            if (this.context.selectedProvider === undefined) {
                this.context.selectProvider(availableProvidersCollection[0], false);
                selectedProvider = availableProvidersCollection[0];
            } else {
                selectedProvider = this.context.selectedProvider;
            }

            return (
                <div>
                    <div className="icon-nav-item-app outline-none" tabIndex="0" onBlur={() => this.setState({ showProviders: false })}>
                        <LinkContainer className="icon-nav-item-app-container" key={`app-item`} to="#">
                            <div>
                                <div className="icon-nav-item-app-icon" title={selectedProvider.split(':')[1]}
                                    onClick={() => this.providerMenuClickHandler()} >
                                    <div className="icon-nav-item-app-text">{this.getSelectedProviderAcronym(selectedProvider)}</div>
                                </div>

                                <div className={showProviders ? "icon-nav-item-available-apps-show icon-nav-item-available-providers-show" : "icon-nav-item-available-apps-hide"}>
                                    {
                                        availableProvidersCollection.map((providerRow, i) =>
                                            <div key={i} className="icon-nav-item-available-provider-icon"
                                                title={providerRow.split(':')[1]}
                                                onClick={() => this.selectProviderHandler(providerRow)} >
                                                {providerRow.split(':')[1]}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </LinkContainer>
                    </div>
                </div>
            );
        } else {
            return (
                <div />
            );
        }
    }

    getSelectedProviderAcronym(selectedProvider) {
        const selectedProviderName = selectedProvider.split(':')[1];
        const selectedProviderAcronym = selectedProviderName.replace(/[^A-Z]/g, '').replace(' ', '');

        if(0 === selectedProviderAcronym.length) {
            return selectedProviderName[0];
        }

        return selectedProviderAcronym;
    }
}
